<section id="kontakt" class="cr-kontakt">
  <header class="cr-kontakt__head">
    <h2 class="cr-kontakt__title">Nicht gefunden, was du suchst?</h2>
    <p class="cr-kontakt__lead">
      Schreib uns über das Formular oder per E-Mail an
      <a href="mailto:info&#64;kulatrix.com">info&#64;kulatrix.com</a>.
      Wir antworten werktags innerhalb von 24 Stunden.
    </p>
  </header>

  @if (status() === 'success' && successTicket(); as ticket) {
    <div class="cr-kontakt__success">
      <span class="cr-kontakt__success-icon" aria-hidden="true">✓</span>
      <div>
        <h3>Wir haben deine Nachricht erhalten.</h3>
        <p>
          Ticket-ID: <code>{{ ticket.id }}</code><br>
          Wir melden uns binnen 24 h werktags an deine angegebene E-Mail-Adresse.
        </p>
      </div>
    </div>
  } @else {
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" class="cr-kontakt__form" novalidate>
      <!-- Honeypot — versteckt für Menschen, von Bots oft ausgefüllt -->
      <input type="text" name="website" tabindex="-1" autocomplete="off"
             [(ngModel)]="honeypot" class="cr-kontakt__honeypot" aria-hidden="true">

      <div class="cr-kontakt__row">
        <label class="cr-kontakt__label" for="kontakt-thema">
          Thema <span class="cr-kontakt__req">*</span>
        </label>
        <select id="kontakt-thema" name="topic" class="cr-input"
                [(ngModel)]="topic" required #topicCtrl="ngModel">
          <option value="" disabled>Thema auswählen…</option>
          @for (t of topics(); track t.value) {
            <option [value]="t.value">{{ t.label }}</option>
          }
        </select>
        @if (topicCtrl.invalid && topicCtrl.touched) {
          <span class="cr-kontakt__err">Bitte wähle ein Thema.</span>
        }
      </div>

      <div class="cr-kontakt__row">
        <label class="cr-kontakt__label" for="kontakt-anliegen">
          Anliegen <span class="cr-kontakt__req">*</span>
        </label>
        <textarea id="kontakt-anliegen" name="body" class="cr-textarea"
                  [(ngModel)]="body" rows="6"
                  maxlength="2000" required
                  placeholder="Beschreibe dein Anliegen so genau wie möglich (min. 50 Zeichen)."></textarea>
        <span class="cr-kontakt__hint">{{ bodyLengthHint() }}</span>
      </div>

      <div class="cr-kontakt__row cr-kontakt__row--two">
        <div>
          <label class="cr-kontakt__label" for="kontakt-name">
            Name <span class="cr-kontakt__req">*</span>
          </label>
          <input id="kontakt-name" name="name" type="text" class="cr-input"
                 [(ngModel)]="name" required maxlength="200"
                 #nameCtrl="ngModel">
          @if (nameCtrl.invalid && nameCtrl.touched) {
            <span class="cr-kontakt__err">Bitte gib einen Namen an.</span>
          }
        </div>

        <div>
          <label class="cr-kontakt__label" for="kontakt-email">
            E-Mail <span class="cr-kontakt__req">*</span>
          </label>
          <input id="kontakt-email" name="emailFrom" type="email" class="cr-input"
                 [(ngModel)]="emailFrom" required maxlength="255" email
                 #emailCtrl="ngModel">
          @if (emailCtrl.invalid && emailCtrl.touched) {
            <span class="cr-kontakt__err">Bitte gib eine gültige E-Mail-Adresse an.</span>
          }
        </div>
      </div>

      <div class="cr-kontakt__row">
        <label class="cr-kontakt__label">Anhang (optional)</label>
        <div class="cr-kontakt__file">
          @if (attachment) {
            <span class="cr-kontakt__file-name">📎 {{ attachment.name }}</span>
            <button type="button" class="cr-kontakt__file-clear"
                    (click)="removeAttachment()">Entfernen</button>
          } @else {
            <input type="file" name="attachment" accept="image/jpeg,image/png,application/pdf"
                   (change)="onAttachmentSelected($event)">
          }
        </div>
        @if (attachmentError(); as err) {
          <span class="cr-kontakt__err">{{ err }}</span>
        } @else {
          <span class="cr-kontakt__hint">Max 5 MB · JPG, PNG oder PDF</span>
        }
      </div>

      <div class="cr-kontakt__consent">
        <label>
          <input type="checkbox" name="consent" [(ngModel)]="consent" required>
          <span>
            Ich habe die
            <a href="/datenschutz" target="_blank" rel="noopener">Datenschutzerklärung</a>
            zur Kenntnis genommen und stimme der Verarbeitung meiner Daten zur
            Bearbeitung dieser Anfrage zu.
          </span>
        </label>
      </div>

      @if (errorMessage(); as err) {
        <div class="cr-kontakt__alert">{{ err }}</div>
      }

      <button type="submit" class="cr-btn cr-btn--primary cr-kontakt__submit"
              [disabled]="status() === 'submitting'">
        @if (status() === 'submitting') { Wird gesendet… } @else { Absenden }
      </button>
    </form>
  }
</section>
